(function () {

    const firstGroupWrapper = document.querySelector('.bundle-wrapper .products-row > .product-wrapper:first-child');
    const secondGroupWrapper = document.querySelector('.bundle-wrapper .products-row > .product-wrapper:nth-child(3)');
    const thirdGroupWrapper = document.querySelector('.bundle-wrapper .products-row > .product-wrapper:nth-child(5)');
    const salePrice = document.querySelector('.bundle-footer price-list sale-price');
    const comparePrice = document.querySelector('.bundle-footer price-list compare-at-price');
    const addToCartBtn = document.querySelector('.bundle-footer button[is="bundle-button"]');
    const bundleQty = document.getElementById('bundle-quantity');
    const flickityOptions = {
        "prevNextButtons": true,
        "contain": true,
        "pageDots": true,
        "freeScroll": false,
        "initialIndex": "1",
        dragThreshold: 50
    };
    let flickity1 = new Flickity(firstGroupWrapper.querySelector('product-list'), flickityOptions),
        flickity2 = new Flickity(secondGroupWrapper.querySelector('product-list')),
        flickity3 = null;
    if (thirdGroupWrapper)
        flickity3 = new Flickity(thirdGroupWrapper.querySelector('product-list'));

    const currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

    var g1SelectedVariant_id = null, g2SelectedVariant_id = null, g3SelectedVariant_id = null;

    function updatePrice() {

        // selected product slide 
        let g1Product = firstGroupWrapper.querySelector('.bundle-card.is-selected');
        let g2Product = secondGroupWrapper.querySelector('.bundle-card.is-selected');

        // get selected product from json 
        let g1SelectedProdudct = tante_e_bundle.g1_products.filter((p) => { return p.id == g1Product.dataset.product })[0];
        let g2SelectedProdudct = tante_e_bundle.g2_products.filter((p) => { return p.id == g2Product.dataset.product })[0];

        //selected variant id from form
        g1SelectedVariant_id = g1Product.querySelector('form input[name="id"]').value;
        g2SelectedVariant_id = g2Product.querySelector('form input[name="id"]').value;

        //filter product to get variant json
        let g1SelectedVariant = g1SelectedProdudct.variants.filter((v) => { return v.id == g1SelectedVariant_id; })[0];
        let g2SelectedVariant = g2SelectedProdudct.variants.filter((v) => { return v.id == g2SelectedVariant_id; })[0];

        if (thirdGroupWrapper) {
            let g3Product = thirdGroupWrapper.querySelector('.bundle-card.is-selected');
            let g3SelectedProdudct = tante_e_bundle.g3_products.filter((p) => { return p.id == g3Product.dataset.product })[0];
            g3SelectedVariant_id = g3Product.querySelector('form input[name="id"]').value;
            var g3SelectedVariant = g3SelectedProdudct.variants.filter((v) => { return v.id == g3SelectedVariant_id; })[0];
        }

        if (g1SelectedVariant.available == false || g2SelectedVariant.available == false || (thirdGroupWrapper && g3SelectedVariant.available == false)) {
            handleBundleBtn(false);
        } else {
            handleBundleBtn(true);
        }

        let discount = tante_e_bundle.discount.replace('%', '');


        // var checkCode = checkDiscountCode();
        // if (checkCode && transferedEvents && transferedEvents.length > 0) {
        //     discount = parseInt(discount) + transferedEvents[0].discount_value;
        //     if (document.querySelector('input[value="legacy-bundle"]') && discount < 20) {
        //         discount = 20;
        //     }
        // }

        //caculate new sale and compare price 
        let newSalePrice = g1SelectedVariant.price + g2SelectedVariant.price;

        if (thirdGroupWrapper) {
            // console.log(" newSalePrice", newSalePrice, g3SelectedVariant.price)
            newSalePrice += g3SelectedVariant.price;
        }
        let newComparePrice = 0;
        (g1SelectedVariant.compare_at_price) ? newComparePrice += g1SelectedVariant.compare_at_price : newComparePrice += g1SelectedVariant.price;
        (g2SelectedVariant.compare_at_price) ? newComparePrice += g2SelectedVariant.compare_at_price : newComparePrice += g2SelectedVariant.price;

        if (thirdGroupWrapper) {
            console.log(" g1SelectedVariant", g1SelectedVariant, g3SelectedVariant.compare_at_price);
            (g3SelectedVariant.compare_at_price) ? newComparePrice += g3SelectedVariant.compare_at_price : newComparePrice += g3SelectedVariant.price;
        }

        console.log('newSalePrice', newSalePrice, 'newComparePrice', newComparePrice, discount);

        if (newSalePrice == comparePrice) {
            comparePrice.setAttribute('hidden', '');
        } else {
            comparePrice.removeAttribute('hidden');
            comparePrice.innerText = formatMoney(newComparePrice, currencyFormat)
        }

        //apply discount on sale price 
        newSalePrice = newSalePrice * (1 - (discount / 100.0));
        salePrice.innerText = formatMoney(newSalePrice, currencyFormat)

    }

    function handleBundleBtn(available = false) {
        addToCartBtn.disabled = !available;
        if (!available) {
            addToCartBtn.firstElementChild.innerHTML = window.themeVariables.strings.unavailableButton;
            addToCartBtn.classList.add("button--subdued");
        } else {
            addToCartBtn.firstElementChild.innerHTML = window.themeVariables.strings.addToCartButton;
            addToCartBtn.classList.remove("button--subdued");

        }
    }

    async function handleAddToCart() {
        addToCartBtn.setAttribute("disabled", "disabled");
        addToCartBtn.setAttribute("aria-busy", "true");
        let quantity = bundleQty.value;
        let bunlde_id = "_BUNDLE_" + new Date().getTime();
        const SELECTED_GENDER_STORAGE_KEY = 'selectedGender';
        const genderFromStorage = localStorage.getItem(SELECTED_GENDER_STORAGE_KEY);

        let items = [
            {
                id: g1SelectedVariant_id,
                quantity: quantity,
                properties: {
                    "_bundle_set": bunlde_id,
                    "_gender": genderFromStorage,
                    "_bundle_item": "1"
                }
            },
            {
                id: g2SelectedVariant_id,
                quantity: quantity,
                properties: {
                    "_bundle_set": bunlde_id,
                    "_gender": genderFromStorage,
                    "_bundle_item": "2"
                }
            }
        ];

        if (window.bundle_order_tag) {
            items[0].properties['_bundle_order_tag'] = window.bundle_order_tag;
        }
        if (thirdGroupWrapper) {
            items.push({
                id: g3SelectedVariant_id,
                quantity: quantity,
                properties: {
                    "_bundle_set": bunlde_id,
                    "_gender": genderFromStorage,
                    "_bundle_item": "3"
                }
            })
        }

        if (document.querySelector('input[value="legacy-bundle"]')) {
            items.forEach((item) => { item.properties['_bundle_type'] = 'legacy'; });
        }
        let sectionsToBundle = ["variant-added"];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            // body: JSON.stringify({ items: items }),
            body: JSON.stringify({ items: items, sections: sectionsToBundle.join(','), sections_url: `${Shopify.routes.root}variants/${g1SelectedVariant_id}` }),
            // body: JSON.stringify({ items: items, section: "variant-added", section_url: `${Shopify.routes.root}variants/${g1SelectedVariant_id}` }),
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        });
        addToCartBtn.removeAttribute("disabled");
        addToCartBtn.removeAttribute("aria-busy");
        const responseJson = await response.json();

        if (response.ok) {
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent["sections"] = responseJson["sections"];
            this.dispatchEvent(new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                    items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                    cart: cartContent
                }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "variant:add",
                    cart: cartContent
                }
            }));
        } else {
            this.dispatchEvent(new CustomEvent("cart:error", {
                bubbles: true,
                detail: {
                    error: responseJson["description"]
                }
            }));
            document.dispatchEvent(new CustomEvent("cart:refresh"));
        }
    }

    document.addEventListener("update-bundle-price", function () {
        updatePrice();
    })
    firstGroupWrapper.addEventListener("variant:change", function () {
        updatePrice();
    })
    secondGroupWrapper.addEventListener("variant:change", function () {
        updatePrice();
    })
    flickity1.on('change', function (e) {
        updatePrice();
    });
    flickity2.on('change', function (e) {
        updatePrice();
    })
    if (flickity3) {
        flickity3.on('change', function (e) {
            updatePrice();
        })
    }

    document.addEventListener('DOMContentLoaded', updatePrice);

    addToCartBtn.addEventListener('click', handleAddToCart);


    function onProductCardGenderChange() {
        const altTextElements = document.querySelectorAll('.featured-media-info');
        altTextElements.forEach((altTextElement) => {
            if (altTextElement) {
                const productMediaId = altTextElement.dataset.productId;

                const genderFromMediaAlt = altTextElement.dataset.alt.split('|')[1];

                const maleImageSrc = altTextElement.dataset.maleImageUrl;
                const maleSecondaryImageSrc = altTextElement.dataset.maleSecondaryImageUrl;

                const femaleImageSrc = altTextElement.dataset.femaleImageUrl;
                const femaleSecondaryImageSrc = altTextElement.dataset.femaleSecondaryImageUrl;

                const primaryImageElement = document.querySelector(`.featured-image-${productMediaId}`);
                const secondaryImageElement = document.querySelector(`.next-image-${productMediaId}`);

                if (genderFromMediaAlt) {
                    const SELECTED_GENDER_STORAGE_KEY = 'selectedGender';
                    const genderFromStorage = localStorage.getItem(SELECTED_GENDER_STORAGE_KEY);

                    if (genderFromStorage === 'men') {
                        if (primaryImageElement) {
                            primaryImageElement.src = maleImageSrc;
                            primaryImageElement.srcset = '';
                        }

                        if (secondaryImageElement) {
                            secondaryImageElement.src = maleSecondaryImageSrc;
                            secondaryImageElement.srcset = '';
                        }
                    } else if (genderFromStorage === 'women') {
                        if (primaryImageElement) {
                            primaryImageElement.src = femaleImageSrc;
                            primaryImageElement.srcset = '';
                        }

                        if (secondaryImageElement) {
                            secondaryImageElement.src = femaleSecondaryImageSrc;
                            secondaryImageElement.srcset = '';
                        }
                    }
                }
            }
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        onProductCardGenderChange();
    });
})();